import React from 'react';
// import { EmprestimoSimuladorProvider } from './EmprestimoSimulador';
import { RecadastramentoProvider } from './Recadastramento';

export const AppProvider: React.FC<any> = ({ children }) => {
  return (
    <RecadastramentoProvider>
      {/* <EmprestimoSimuladorProvider> */}
      {children}
      {/* </EmprestimoSimuladorProvider> */}
    </RecadastramentoProvider>
  );
};
